/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsTrailDetails {
    getFixupPrototypeFunction() { return AwsTrailDetails.fixupPrototype; }

    static newInstance(model: Partial<AwsTrailDetails>): AwsTrailDetails {
        let obj = Object.assign(new AwsTrailDetails(), model);
        AwsTrailDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsTrailDetails>): AwsTrailDetails {
        if (!model) return null;
        return AwsTrailDetails.newInstance(<AwsTrailDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsTrailDetails) {
        if (!obj) return;

        models.AwsTrailDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsTrailDetails): boolean {
        Object.setPrototypeOf(obj, AwsTrailDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the trail
     */
    name: string;

    /**
     * Name of the Amazon S3 bucket into which CloudTrail delivers trail files
     */
    bucket_name: string;

    /**
     * Specifies whether the trail exists only in one Region or exists in all Regions
     */
    is_multi_region_trail: boolean;

}
